import { render, staticRenderFns } from "./LinkToSignup.vue?vue&type=template&id=7671b3fa&scoped=true"
import script from "./LinkToSignup.vue?vue&type=script&lang=js"
export * from "./LinkToSignup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7671b3fa",
  null
  
)

export default component.exports